import React, { Component } from 'react'
import {Container, Row, Col} from '../../../SPRINTA/atoms/Grid'
import CoverImage from '../../../SPRINTA/atoms/CoverImage'
import T from '../../../SPRINTA/translate/T'
import Button from '../../../SPRINTA/atoms/Button'
import Loading from '../../../SPRINTA/atoms/Loading'
import Placeholder from '../../../SPRINTA/atoms/PlaceHolder'
import FontIcon from '../../Components/Atom/FontIcon'
import styles from './styles.css'
import { dateFormat } from '../../../SPRINTA/helpers/Formatter'

// import {CopyToClipboard} from 'react-copy-to-clipboard'

import * as event from '../../Utils/event'
import SocialShare from '../../../SPRINTA/atoms/SocialShare';

export default class EventOk extends Component {
    state = {
        copied: false,
        loading: true,
        event: null,
        publishing: false
    }

    componentWillMount() {
        window.scrollTo(0, 0)
        let token = this.props.match.params.token

        event.getEventToken(token)
        .then(data => {
            if(data.errors.length > 0) window.location.href = '/'
            this.setState({
                loading: false,
                event: data.event
            })
        })

    }


    handlePublish() {
        this.setState({
            publishing: true
        })

        event.publish(this.state.event.id)
        .then(() => {
            this.setState({
                publishing: false,
                event: {
                    ...this.state.event,
                    situation: 3
                }
            })
        })
    }

    render(){

        return(
            <CoverImage className={styles.bg} image={require('./background.jpg')}>

                {this.state.loading ? (
                    <Container>
                        <Row>
                            <Col size='12 10 8' float='center'>
                                <Placeholder type="box" style={{height: '60px'}} />
                            </Col>

                            <br/>

                            <Col size='12 10 8' float='center'>
                                <Placeholder type="box" style={{height: '400px'}} />
                            </Col>
                        </Row>
                    </Container>
                ) : (

                    <Container>
                        <Row>
                            <Col size='12 10 8' float='center'>
                                <h1>{T.text('create_your_event_page_event_ok_event_congrats_title')}</h1>
                                <p>{T.text('create_your_event_page_event_ok_event_congrats_text')}</p>
                            </Col>
                            <Col size='12 10 8' float='center'>
                                <div className={styles.cardContent} style={{marginBottom:'50px'}}>

                                    <CoverImage className={styles.top} shadow={300} image={this.state.event.coverImagePath}>

                                        <Row>
                                            <Col size="12">
                                                <h1>{this.state.event.title}</h1>
                                            </Col>
                                            <Col size="7 3">
                                                <p>{T.text('create_your_event_page_event_ok_event_day')}</p>
                                                <p><b>{dateFormat(T.txt('date_format_simple'), this.state.event.startDate)}</b></p>
                                            </Col>
                                            <Col size="5 2">
                                                <p>{T.text('create_your_event_page_event_ok_event_hour')}</p>
                                                <p><b>{this.state.event.time}</b></p>
                                            </Col>
                                            <Col size="12">
                                                <p>{T.text('create_your_event_page_event_ok_event_local')}</p>
                                                <p><b>{this.state.event.city} ({this.state.event.region})</b></p>
                                            </Col>
                                        </Row>

                                    </CoverImage>

                                    <Row>
                                        {this.state.event.situation !== 3 && (
                                            <Col>
                                                <div className={styles.naopublicado}>
                                                    <p>{T.text('create_your_event_page_event_ok_event_notpublished')}</p>
                                                </div>
                                            </Col>
                                        )}

                                        {this.state.event.situation === 3 && (
                                            <Col>
                                                <div className={styles.publicado}>
                                                    <p>{T.text('create_your_event_page_event_ok_event_published')}</p>
                                                </div>
                                            </Col>
                                        )}

                                        {this.state.event.situation === 3 && (
                                            <Col>
                                                <div className={styles.eventlink}>
                                                    <p>{T.text('create_your_event_page_event_ok_event_link')}</p>
                                                    {/* <CopyToClipboard onCopy={() => this.setState({copied: true})} text="http://app.sprinta.com.br/event/17WB8fqBFI"> */}
                                                        <a style={{color: '#fff'}} href={`${window.EVENT_PUBLISHED_URL}${this.state.event.token}`}>
                                                            <span>{/*<FontIcon name="copy" color="white" size={18} />*/} {window.EVENT_PUBLISHED_URL}{this.state.event.token}</span>
                                                        </a>
                                                    {/* </CopyToClipboard> */}
                                                    {/* <div className={styles.copied}>
                                                        {this.state.copied ? <div>{T.text('create_your_event_page_event_ok_event_copy_link')}</div> : null}
                                                    </div> */}
                                                </div>
                                            </Col>
                                        )}

                                        <Col>
                                            <div className={styles.content}>
                                                {this.state.event.situation !== 3 && (

                                                    <Row>
                                                        <Col size='12 9' text='center left' style={{marginBottom: '20px'}}>
                                                            <div className={styles.titlePublish}>{T.text('publish_event')}</div>
                                                            <div className={styles.msgPublish}>{T.text('publish_event_description')}</div>
                                                        </Col>
                                                        <Col size='12 3' text='center right'>
                                                            {this.state.publishing ? (
                                                                <Loading />
                                                            ) : (
                                                                <Button inline theme="primary" onClick={() => this.handlePublish()}>
                                                                    {T.text('publish')}
                                                                </Button>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                )}

                                                <div className={styles.config}>
                                                    <Row>
                                                        <Col size="12 6" style={{marginBottom: '30px'}}>
                                                            <FontIcon name="event_config" color="#ff5500" size={40} />
                                                            <h1>{T.text('create_your_event_page_event_ok_event_config_left_title')}</h1>
                                                            <p>{T.text('create_your_event_page_event_ok_event_config_left_text')}</p>
                                                            <a href={`${window.PANEL_LINK}${this.state.event.token}`} style={{float: 'left', width: '100%'}}>
                                                                <Button inline theme="primary">{T.text('create_your_event_page_event_ok_event_config_left_button')}</Button>
                                                            </a>
                                                        </Col>

                                                        <Col size="12 6">
                                                            <FontIcon name="admin_notification" color="#ff5500" size={40} />
                                                            <h1>{T.text('create_your_event_page_event_ok_event_config_right_title')}</h1>

                                                            {this.state.event.situation === 3 ? (
                                                                <p>{T.text('create_your_event_page_event_ok_event_config_right_text')}</p>
                                                            ) : (
                                                                <p>{T.text('publish_before_sharing')}</p>
                                                            )}


                                                            <span style={{ pointerEvents: this.state.event.situation !== 3 ? 'none' : '', opacity: this.state.event.situation !== 3 ? '0.3' : '' }}>
                                                                <SocialShare type='Facebook' href={`${window.PANEL_LINK}${this.state.event.token}`}>
                                                                    <FontIcon name="facebook" color="#ff5500" size={30} />
                                                                </SocialShare>
                                                                &nbsp;&nbsp;&nbsp;&nbsp;
                                                                <SocialShare type='Twitter' href={`${window.PANEL_LINK}${this.state.event.token}`}>
                                                                    <FontIcon name="twitter" color="#ff5500" size={30} />
                                                                </SocialShare>
                                                            </span>
                                                        </Col>

                                                    </Row>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>

                            </Col>
                        </Row>
                    </Container>

                )}

            </CoverImage>
        )
    }
}



// WEBPACK FOOTER //
// ./src/App/pages/EventOk/index.js